export default __webpack_public_path__ + "static/media/pencil-clear-spring.84156848.png";